import { render, staticRenderFns } from "./LargeOrderNotification.vue?vue&type=template&id=4e5f8908&scoped=true&"
import script from "./LargeOrderNotification.vue?vue&type=script&lang=js&"
export * from "./LargeOrderNotification.vue?vue&type=script&lang=js&"
import style0 from "./LargeOrderNotification.vue?vue&type=style&index=0&id=4e5f8908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5f8908",
  null
  
)

export default component.exports